function fn1(current) {
    var tl = new TimelineLite({onComplete:test});
    tl.staggerTo(".col-md-4", 1, {rotation:360, y:100}, 0.5);
}